exports.cs = {
  UNIFORM_DETAIL: {
    INVALID_RADIO: 'Vyberte jednu z možností.'
  }
}
